/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './Descriptions.scss'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import NumberFormat from 'react-number-format'
import { renderToString } from 'react-dom/server'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IDescriptionsProps {
	data: IInpatientTypeInsurance
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IDescriptionsState {}

export class DescriptionsComponent extends React.Component<IDescriptionsProps, IDescriptionsState> {
	render(): React.ReactNode {
		const descriptionsModel = this.props.data
		let row = ''
		let header = 'Descriptions'
		if (descriptionsModel.descriptions) {
			descriptionsModel.descriptions.forEach(element => {
				row += row.length > 0 ? '<br />' : ''
				if (element.isHospice) {
					header = 'Total # of Occurrences'
					row += element.occurences
				} else {
					const dates = CommonUtils.DateRange(element.startDate, element.endDate, true)
					if (element.startDate.length !== 0 || element.endDate.length !== 0) {
						row += dates + '&nbsp;&nbsp;'
					}
					row += (!element.message ? '' : element.message) + ': <strong>' + this.getAmount(element.amount) + '</strong>'
				}
			})
			let index = 0
			if (descriptionsModel.descriptions.length > 0) {
				index++
				return (
					<tr key={index}>
						<td>{header}:</td>
						<td colSpan={3}>{parse(row)}</td>
					</tr>
				)
			}
		}

		return <></>
	}
	getAmount(amount: string | number): string {
		return renderToString(<NumberFormat value={amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} />)
	}
}
